import type { TimeSlot } from '@klareospace/pharos-lib-types';

/**
 * Far-future sentinel date, used to sort entries with a missing/undefined time value last in
 * ascending-order comparisons (e.g. delivery/pickup stops without a time slot).
 */
export const FAR_FUTURE_DATE = new Date('9999-12-31T23:59:59.999Z');

/** True when a time slot's end is not strictly after its start (invalid/inverted range). */
export function isInvertedTimeSlot(slot: TimeSlot): boolean {
  return new Date(slot.end).getTime() <= new Date(slot.start).getTime();
}

export function toDate(value: Date | string | null | undefined): Date | undefined {
  if (!value) return undefined;
  return value instanceof Date ? value : new Date(value);
}

export function getStartOfToday(): string {
  const d = new Date();
  d.setHours(0, 0, 0, 0);
  return d.toISOString();
}

/** Last calendar day (1-31) of a given UTC year/month (1-indexed month). */
export function lastDayOfMonthUtc(year: number, month: number): number {
  return new Date(Date.UTC(year, month, 0)).getUTCDate();
}
